import styled from 'styled-components';
import CloseIcon from 'assets/images/close-24.svg';

const ModalBlockSection = styled.div`
  color: ${props => props.theme.color.text};
  padding: 1em 2em;
  ${props => props.borderBottom && `border-bottom: 1px solid ${props.theme.color.border}`};
  ${props => props.borderTop && `border-top: 1px solid ${props.theme.color.border}`};
`;

const ModalWrapper = styled.div`
  button:not(:disabled):hover {
    cursor: pointer;
    opacity: 0.8;
  }
  @media all and (max-width: 567px) {
    font-size: 0.8em;
    /* margin-left: -15px; */
  }
`;

const ModalHeader = styled.div`
  padding: 15px;
  border-bottom: 1px solid;
  border-color: ${props => props.theme.color.border};
  color: ${props => props.theme.color.text};
`;

const ModalBody = styled.div`
  padding: 15px;
`;

const ModalCloseIcon = styled.img.attrs({
  src: CloseIcon
})`
  float: right;
  &:hover {
    cursor: pointer;
  }
`;

const ModalTitle = styled.div`
  clear: both;
  text-align: left;
  font-size: 1.5em;
`;

const ModalText = styled.div`
  text-align: left;
  font-size: 1.125em;
  margin-bottom: 30px;
  &.bn-m-small {
    margin-bottom: 0.5em;
  }
`;

const ModalFooter = styled.div`
  position: relative;
  font-size: 1em;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.9em 30px;
  border-top: 1px solid ${props => (props.topBorder ? props.theme.color.border : 'transparent')};
  .resolve-message {
    position: absolute;
    top: -1px;
    right: 31px;
    font-size: 0.8em;
    color: ${p => p.theme.color.successGreen};
  }
`;

const ModalFooterCancelBtn = styled.button`
  font-size: 1em;
  font-weight: 500;
  text-align: left;
  padding: 0;
  color: ${props => props.theme.color.error};
  background-color: transparent;
`;

const ModalFooterBtn = styled.button`
  font-size: 1em;
  padding: 0.72em 2.5em;
  border-width: 2px;
  border-style: solid;
  border-color: ${props => props.theme.color.primary};
  color: ${props => (props.bgTransparent ? props.theme.color.primary : 'white')};
  border-radius: 4px;
  background-color: ${props => (props.bgTransparent ? 'transparent' : props.theme.color.primary)};
  &:hover {
    cursor: pointer;
    opacity: 0.8;
  }
  &:disabled {
    pointer-events: none;
    color: ${props => (props.bgTransparent ? props.theme.color.disabled : 'white')};
    background-color: ${props =>
    props.bgTransparent ? 'transparent' : props.theme.color.disabled};
    border-color: ${props => props.theme.color.disabled};
  }
`;

const CommonModalWrapper = styled.div`
  .header-wrapper {
    padding-bottom: 0.3em;
  }
  .close-icon {
    margin-right: -1em;
  }
  .input-label {
    font-size: 1.1em;
    &:not(:empty) {
      margin-bottom: 0.6em;
    }
  }
  .optional {
    padding-top: 1.2em;
    padding-bottom: 1.2em;
  }
  .sides {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    label {
      width: inherit;
      margin-left: 16%;
    }
    .error-groupe-message {
      width: 100%;
      display: inline-block;
      text-align: right;
      color: ${props => props.theme.color.error};
      font-size: 0.8em;
    }
  }
  .sides.show-group-error {
    label > div {
      border-color: ${props => props.theme.color.error};
    }
  }
  .footer {
    button {
      padding: 0.6em;
      &:last-of-type {
        min-width: 170px;
      }
    }
  }
  .error-message {
    padding-top: 0.3em;
    font-size: 0.8em;
    width: 100%;
    display: inline-block;
    color: ${props => props.theme.color.error};
  }
`;

const ModalCancel = styled.span`
  cursor: pointer;
  font-size: 1em;
  font-weight: 500;
  color: ${props => props.theme.color.error};
  &:hover {
    opacity: 0.7;
  }
`;

export {
  CommonModalWrapper,
  ModalBlockSection,
  ModalWrapper,
  ModalHeader,
  ModalCloseIcon,
  ModalTitle,
  ModalText,
  ModalFooterCancelBtn,
  ModalFooterBtn,
  ModalCancel,
  ModalBody,
  ModalFooter
};
